export const LOT_PLAN = 'Lot/Plan';
export const BLOCK_SECTION = 'Section/Block';

export const parcelTypes = [
    LOT_PLAN,
    BLOCK_SECTION,
];

export default parcelTypes;
